<template>
  <div class="topmenu">
    <div class="header__bg"></div>
    <b-container>
      <b-row>
        <b-col>
          <b-navbar toggleable="lg" type="dark">
            <b-navbar-brand href="#">
              <router-link to="/">
                <b-img-lazy v-bind="logoProps" :src="$store.state.configs.brand_logo_white"
                  :alt="$store.state.configs.brand_name"></b-img-lazy>
              </router-link>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="m-auto">
                <b-nav-item class="top-menu dropdown" href="#">{{ $store.state.labels.MENU_SERVICES }}
                  <div class="dropdown-content">
                    <ul>
                      <li v-for="menu in $store.state.menu" v-bind:key="menu.content_id">
                        <router-link :to="'/' +
                          $store.state.selectlanguage +
                          '/product/' +
                          menu.content_id +
                          '/' +
                          convertToSlug(menu.content_title_menu)
                          ">
                          <img :alt="menu.content_subtitle" :src="menu.icon_menu" />
                          {{ menu.content_title_menu }}<br /><span>{{
                            menu.content_subtitle
                          }}</span>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </b-nav-item>
                <b-nav-item class="top-menu" :to="'/' + $store.state.selectlanguage + '/company/profile'">
                  {{ $store.state.labels.MENU_COMPANY }}
                </b-nav-item>
                <b-nav-item class="top-menu" :to="'/' + $store.state.selectlanguage + '/contact-us/submit'">{{
                  $store.state.labels.MENU_CONTACTUS }}
                </b-nav-item>
              </b-navbar-nav>
              <b-navbar-nav class="top-menu-right">
                <b-nav-item href="#"><span @click="switchLanguage('en')"><img class="flag" alt="English"
                      src="https://www.sentineltech.com/assets/images/flag-of-United-States-of-America.png" />
                    EN</span>
                  |
                  <span @click="switchLanguage('id')"><img class="flag" alt="English"
                      src="https://www.sentineltech.com/assets/images/flag-of-Indonesia.png" />
                    ID</span></b-nav-item>
                <b-nav-item class="btn-top-right" href="https://customers.sentineltech.com">
                  <b-button class="btn-signin" size="sm">{{ $store.state.labels.SIGN_IN }} >
                  </b-button>
                </b-nav-item>
                <b-nav-item class="btn-top-right" href="https://customers.sentineltech.com/#/register">
                  <b-button class="btn-register" size="sm">REGISTER > </b-button>
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
          <Slide right :closeOnNavigation="true">
            <router-link to="/">
              <span>{{ $store.state.labels.LABEL_HOME }}</span>
            </router-link>
            <a href="#">
              <span>{{ $store.state.labels.MENU_SERVICES }}</span>
            </a>
            <ul class="ul-menu-slide">
              <li v-for="menu in $store.state.menu" v-bind:key="menu.content_id">
                <router-link :to="'/' +
                  $store.state.selectlanguage +
                  '/product/' +
                  menu.content_id +
                  '/' +
                  convertToSlug(menu.content_title_menu)
                  ">{{ menu.content_title_menu }}</router-link>
              </li>
            </ul>
            <router-link :to="'/' + $store.state.selectlanguage + '/company/profile'">
              <span>{{ $store.state.labels.MENU_COMPANY }}</span>
            </router-link>
            <router-link :to="'/' + $store.state.selectlanguage + '/contact-us/submit'">
              <span>{{ $store.state.labels.MENU_CONTACTUS }}</span>
            </router-link>
            <span>
              <a class="flag-mobile" href="#" @click="switchLanguage('en')">EN</a>
              |
              <a class="flag-mobile" href="#" @click="switchLanguage('id')">ID</a>
            </span>
            <span>
              <b-button href="https://customers.sentineltech.com" class="btn-signin" size="sm">{{
                $store.state.labels.SIGN_IN }} >
              </b-button>
            </span>
            <span>
              <b-button href="https://customers.sentineltech.com/#/register" class="btn-register" size="sm">REGISTER >
              </b-button>
            </span>
          </Slide>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { AppService } from './../service/main'
import { Slide } from "vue-burger-menu";
import router from "../router";
export default {
  name: "TopMenu",
  components: {
    Slide,
  },
  data() {
    return {
      menus: [],
      logoProps: {
        center: true,
        fluidGrow: false,
        blank: true,
        blankColor: "#bbb",
        class: "img-logo",
      },
    };
  },
  methods: {
    convertToSlug(Text) {
      return Text.toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    },

    async switchLanguage(lang) {

      var setLang = 1;
      if (lang === "en") {
        this.$store.commit("switchLanguage", 1);
        setLang = 1;
      } else if (lang === "id") {
        this.$store.commit("switchLanguage", 2);
        setLang = 2;
      } else {
        this.$store.commit("switchLanguage", 1);
        setLang = 6;
      }
      await AppService.getLabel('label', setLang)
        .then((response) => {
          this.$store.commit("savelabel", response.content);
        })
        .catch((e) => {
          console.log(e)
        })
      this.$store.commit("changeLanguage", lang);
      //console.log(lang);
      //console.log(this.$router.currentRoute.path);
      var getpath = this.$router.currentRoute.path;
      if (typeof this.$route.params.lang === "undefined") {
        router.push({ path: "/" + lang + getpath });
      } else {
        if (lang != this.$route.params.lang) {
          var newpath = getpath.slice(3);
          router.push({ path: newpath });
        }
      }
    },
  },
};
</script>

<style>
.header-tag {
  /* background: #2aa6ef; */
  position: relative;
  min-height: 800px;
  overflow: auto;
}

.header__bg {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to right, #109bf8, #57b2c4);
  transform: skewY(-8deg);
  transform-origin: top left;
}

.img-logo {
  max-width: 120px;
}

.header-content {
  margin: 30px auto;
}

.header-content-grid {
  padding: 10px;
}

.header-content-grid h1 {
  margin-top: 50px;
  color: #fff;
  font-weight: bold;
  text-align: left;
}

.header-content-grid h1 span {
  color: #000;
}

.header-content-grid p {
  margin-top: 20px;
  margin-bottom: 20px;
  color: #fff;
  text-align: left;
  font-size: 0.9em;
}

.header-button {
  margin-top: -10px;
}

.navbar {
  margin-top: 25px;
}

.btn-top-right {
  margin: 0 !important;
}

.btn-signin {
  margin-top: -5px !important;
  font-weight: 700;
  font-size: 1.2em;
  padding-left: 25px;
  padding-right: 25px;
  background: #5fd8f4;
  border: none;
}

.btn-signin:hover {
  background: #4ec9e6;
}

.btn-register {
  margin-top: -5px !important;
  font-weight: 700;
  font-size: 1.2em;
  padding-left: 25px;
  padding-right: 25px;
  background: #ff1493;
  border: none;
}

.btn-register:hover {
  background: #db127f;
}

.bm-burger-button {
  display: none;
}

.m-auto {
  margin: 0 auto;
}

.nav-item {
  margin: 0 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.top-menu a {
  color: #fff !important;
  display: inline-block;
}

.top-menu a:hover {
  color: #fff !important;
}

.top-menu a::after {
  content: "";
  display: block;
  width: 0px;
  height: 3px;
  background: #fff;
  transition: width 0.3s;
  margin: 0 auto;
  text-align: center;
}

.top-menu a:hover::after {
  width: 25%;
  text-align: center;
}

.flag-version {
  float: left;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 1) !important;
  border-color: rgba(255, 255, 255, 1) !important;
}

.flag {
  max-width: 20px;
  margin-top: -5px;
}

.top-menu-right {
  font-size: 13px;
}

.top-menu-right a,
.top-menu-right a:hover {
  color: #fff !important;
}

.bm-menu {
  background-color: #133d54 !important;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 300px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 20px 25px;
  z-index: 1;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  text-align: left;
  margin-top: 20px;
  margin-left: -125%;
}

.dropdown-content:after {
  content: "";
  position: absolute;
  right: 135px;
  top: -10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 17px 17px 17px;
  border-color: transparent transparent #ffffff transparent;
  z-index: 9998;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content ul {
  margin-left: 0;
  padding-left: 0;
  color: #0a75b0;
  font-size: 1em;
  text-transform: none;
}

.dropdown-content ul li {
  list-style: none;
  margin: 22px 0;
  padding-left: 50px;
  position: relative;
  line-height: 20px;
}

.dropdown-content ul li img {
  position: absolute;
  margin-left: -60px;
  max-width: 40px;
}

.dropdown-content ul li span {
  font-size: 0.8em;
  color: #6b97b0;
}

.dropdown-content ul li a,
.dropdown-content ul li a:hover {
  color: #0a75b0 !important;
  text-decoration: none;
}

.ul-menu-slide {
  display: block !important;
  text-align: left !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.ul-menu-slide li {
  padding-left: 23px !important;
  list-style: none !important;
  color: #fff !important;
  margin: 15px 0 !important;
}

.ul-menu-slide li a,
.ul-menu-slide li a:hover {
  color: #fff !important;
  text-decoration: none !important;
}

.bm-item-list {
  margin-left: 5% !important;
}

.flag-mobile {
  color: #fff;
  padding-left: 10px;
  padding-right: 10px;
}

.flag-mobile:visited {
  text-decoration: none;
  color: #fff;
}

@media (max-width: 768px) {
  .navbar-collapse {
    background: #109bf8;
    text-align: left;
  }

  .navbar-toggler {
    display: none;
  }

  .bm-burger-button {
    display: initial;
    color: #fff !important;
    width: 50px;
    height: 50px;
    -webkit-border-radius: 9px;
    -moz-border-radius: 9px;
    border-radius: 9px;
  }

  .bm-burger-bars {
    background-color: #fff !important;
  }

  .line-style {
    height: 6px;
    left: 0;
    position: absolute;
    right: 0;
  }

  .bm-burger-button span {
    margin: 0 auto;
  }

  .btn-signin,
  .btn-register {
    font-size: 1em;
  }
}
</style>
